/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WatchPortalUpdatesStudioSubscriptionVariables = {|
  id: string
|};
export type WatchPortalUpdatesStudioSubscriptionResponse = {|
  +portalUpdates: ?{|
    +_id: string,
    +name: string,
    +coverpages: $ReadOnlyArray<?{|
      +_id: string,
      +id: string,
      +details: string,
      +mainHeading: string,
      +name: string,
      +portalId: string,
      +showroomIds: ?$ReadOnlyArray<string>,
      +templateStyle: ?{|
        +cardPosition: ?string,
        +BackgroundBlur: ?string,
      |},
      +showroomLink: string,
      +templateId: number,
      +thumbnail: ?string,
    |}>,
    +showrooms: $ReadOnlyArray<?{|
      +_id: string,
      +id: string,
      +portalId: ?string,
      +name: string,
      +mainHeading: string,
      +subHeading: string,
      +headerImage: ?string,
      +templateId: number,
      +tags: ?$ReadOnlyArray<string>,
      +link: ?string,
      +content: ?$ReadOnlyArray<?{|
        +name: string,
        +content: ?$ReadOnlyArray<?{|
          +image: string,
          +imageUrl: string,
          +mainHeading: string,
          +presentationId: string,
          +subHeading: string,
          +presentation: ?{|
            +coverUrl: ?string,
            +portalId: string,
            +name: string,
            +menuId: string,
            +folderId: string,
          |},
          +files: ?$ReadOnlyArray<?{|
            +_id: string,
            +name: string,
            +relatedPresentationIds: $ReadOnlyArray<string>,
            +fileUrl: string,
            +fileType: string,
            +coverUrl: ?string,
            +thumbnailUrl: ?string,
            +visibility: ?boolean,
            +creator: string,
          |}>,
        |}>,
      |}>,
    |}>,
    +microsites: $ReadOnlyArray<?{|
      +_id: string,
      +id: string,
      +name: string,
      +showroomsIds: ?$ReadOnlyArray<string>,
      +backgroundImage: ?string,
      +coverpageId: ?string,
      +tags: ?$ReadOnlyArray<string>,
      +templateId: ?number,
      +portalId: string,
      +creator: string,
      +accountId: string,
      +thumbnailUrl: ?string,
    |}>,
    +magazines: $ReadOnlyArray<?{|
      +_id: string,
      +id: string,
      +name: string,
      +backgroundColor: ?string,
      +backgroundImage: ?string,
      +mainTemplateId: string,
      +subTemplateId: number,
      +portalId: string,
      +rows: ?$ReadOnlyArray<?{|
        +content: ?$ReadOnlyArray<?{|
          +description: ?string,
          +headerImage: ?string,
          +fileUrl: ?string,
          +videoThumbnail: ?string,
          +cardThumbnail: ?string,
          +headerOverlayContent: ?string,
          +heading: ?string,
          +subHeading: ?string,
          +linkTo: ?string,
          +buttonText: ?string,
          +graphData: ?{|
            +attr1: ?string,
            +attr2: ?string,
            +attr3: ?string,
            +data: ?$ReadOnlyArray<?{|
              +name: ?string,
              +val1: ?number,
              +val2: ?number,
              +val3: ?number,
            |}>,
          |},
        |}>,
        +isShown: ?boolean,
      |}>,
      +thumbnail: ?string,
      +tags: ?$ReadOnlyArray<?string>,
      +creator: string,
      +accountId: ?string,
    |}>,
  |}
|};
export type WatchPortalUpdatesStudioSubscription = {|
  variables: WatchPortalUpdatesStudioSubscriptionVariables,
  response: WatchPortalUpdatesStudioSubscriptionResponse,
|};
*/


/*
subscription WatchPortalUpdatesStudioSubscription(
  $id: ID!
) {
  portalUpdates(id: $id) {
    _id
    name
    coverpages {
      _id
      id
      details
      mainHeading
      name
      portalId
      showroomIds
      templateStyle {
        cardPosition
        BackgroundBlur
      }
      showroomLink
      templateId
      thumbnail
    }
    showrooms {
      _id
      id
      portalId
      name
      mainHeading
      subHeading
      headerImage
      templateId
      tags
      link
      content {
        name
        content {
          image
          imageUrl
          mainHeading
          presentationId
          subHeading
          presentation {
            coverUrl
            portalId
            name
            menuId
            folderId
          }
          files {
            _id
            name
            relatedPresentationIds
            fileUrl
            fileType
            coverUrl
            thumbnailUrl
            visibility
            creator
          }
        }
      }
    }
    microsites {
      _id
      id
      name
      showroomsIds
      backgroundImage
      coverpageId
      tags
      templateId
      portalId
      creator
      accountId
      thumbnailUrl
    }
    magazines {
      _id
      id
      name
      backgroundColor
      backgroundImage
      mainTemplateId
      subTemplateId
      portalId
      rows {
        content {
          description
          headerImage
          fileUrl
          videoThumbnail
          cardThumbnail
          headerOverlayContent
          heading
          subHeading
          linkTo
          buttonText
          graphData {
            attr1
            attr2
            attr3
            data {
              name
              val1
              val2
              val3
            }
          }
        }
        isShown
      }
      thumbnail
      tags
      creator
      accountId
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainHeading",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "portalId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subHeading",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerImage",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creator",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundImage",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Portal",
    "kind": "LinkedField",
    "name": "portalUpdates",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Coverpage",
        "kind": "LinkedField",
        "name": "coverpages",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "details",
            "storageKey": null
          },
          (v4/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showroomIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateStyle",
            "kind": "LinkedField",
            "name": "templateStyle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "BackgroundBlur",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showroomLink",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Showroom",
        "kind": "LinkedField",
        "name": "showrooms",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v6/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NestedContent",
                "kind": "LinkedField",
                "name": "content",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "presentationId",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "presentation",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v5/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "menuId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "folderId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "files",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relatedPresentationIds",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fileType",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Microsite",
        "kind": "LinkedField",
        "name": "microsites",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showroomsIds",
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverpageId",
            "storageKey": null
          },
          (v10/*: any*/),
          (v6/*: any*/),
          (v5/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Magazine",
        "kind": "LinkedField",
        "name": "magazines",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundColor",
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mainTemplateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subTemplateId",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Row",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Card",
                "kind": "LinkedField",
                "name": "content",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoThumbnail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardThumbnail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headerOverlayContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "heading",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkTo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Graph",
                    "kind": "LinkedField",
                    "name": "graphData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attr1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attr2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attr3",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "val1",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "val2",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "val3",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isShown",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v10/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WatchPortalUpdatesStudioSubscription",
    "selections": (v17/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchPortalUpdatesStudioSubscription",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "6259b5d33f2464217b8004be293f09c3",
    "id": null,
    "metadata": {},
    "name": "WatchPortalUpdatesStudioSubscription",
    "operationKind": "subscription",
    "text": "subscription WatchPortalUpdatesStudioSubscription(\n  $id: ID!\n) {\n  portalUpdates(id: $id) {\n    _id\n    name\n    coverpages {\n      _id\n      id\n      details\n      mainHeading\n      name\n      portalId\n      showroomIds\n      templateStyle {\n        cardPosition\n        BackgroundBlur\n      }\n      showroomLink\n      templateId\n      thumbnail\n    }\n    showrooms {\n      _id\n      id\n      portalId\n      name\n      mainHeading\n      subHeading\n      headerImage\n      templateId\n      tags\n      link\n      content {\n        name\n        content {\n          image\n          imageUrl\n          mainHeading\n          presentationId\n          subHeading\n          presentation {\n            coverUrl\n            portalId\n            name\n            menuId\n            folderId\n          }\n          files {\n            _id\n            name\n            relatedPresentationIds\n            fileUrl\n            fileType\n            coverUrl\n            thumbnailUrl\n            visibility\n            creator\n          }\n        }\n      }\n    }\n    microsites {\n      _id\n      id\n      name\n      showroomsIds\n      backgroundImage\n      coverpageId\n      tags\n      templateId\n      portalId\n      creator\n      accountId\n      thumbnailUrl\n    }\n    magazines {\n      _id\n      id\n      name\n      backgroundColor\n      backgroundImage\n      mainTemplateId\n      subTemplateId\n      portalId\n      rows {\n        content {\n          description\n          headerImage\n          fileUrl\n          videoThumbnail\n          cardThumbnail\n          headerOverlayContent\n          heading\n          subHeading\n          linkTo\n          buttonText\n          graphData {\n            attr1\n            attr2\n            attr3\n            data {\n              name\n              val1\n              val2\n              val3\n            }\n          }\n        }\n        isShown\n      }\n      thumbnail\n      tags\n      creator\n      accountId\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '881b8d8e48d8c379996a86b21dd645a1';

module.exports = node;
